module.exports = __webpack_public_path__ + "static/media/gift-list6-active.082e4c92.png";